export const invoicesConstants = {
	EXPORT_DATA: 'EXPORT_DATA',
	DOWNLOAD_DATA: 'DOWNLOAD_DATA'
}

export const invoiceStatus = {
	PAYED: 'Paga',
	CLOSED: 'Fechada',
	DELAYED: 'Vencida',
	PENDING: 'Aberta'
}
